module.exports = __webpack_public_path__ + "assets/6e972fe1acad3c8ef4ce19bc732819df.png";